import React, { useState, useContext, useEffect } from 'react';
import swal from 'sweetalert';
import { getMunicipios } from '../../services/leadMunicipiosService';
import EstablecimientosPage from '../../pages/LeadsPage/EstablecimientosPage/EstablecimientosPage';

import { permitsList, swalMessages } from '../../constants';
import { Context } from '../../context/Contex';

import { getVehiculos } from '../../services/vehiculosService';
import { getDepartamentos } from '../../services/leadDepartamentosService';
import {
  getEstablecimientoTvs,
  postEstablecimiento,
  putEstablecimiento,
  deleteEstablecimiento,
} from '../../services/establecimientosService';

const searchArray = {
  ciudad: null,
  estado: null,
  impulsa: null,
  estrategia: null,
  departamento: null,
  linea: null,
};

const initialForm = {
  id: '',
  nit: '',
  retoma: 0,
  score: '0.0',
  estado: 1,
  impulsa: 0,
  ciudad: '',
  latitud: '',
  celular: '',
  horario: '',
  longitud: '',
  direccion: '',
  financiacion: 0,
  telefono_fijo: '',
  departamento: '',
  sitio_web_b2w: 0,
  equipo_digital: 0,
  tiempo_gestion: '',
  razon_comercial: '',
  tasa_conversion: '',
  token_integracion: '',
  correo_electronico: '',
  codigo_destinatario: '',
  nombre_establecimiento: '',
  establecimientoCiudades: [],
  establecimientoVehiculos: [],
  establecimientoTestdriveVehiculos: [],
};
const initialControls = {
  ciudadControl: null,
  vehiculosControl: [],
  testDriveControl: [],
  sucursalesControl: [],
};

const EstablecimientosTVSContainer = () => {
  const [details, setDetails] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [vehiculos, setVehiculos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [filterArray, setFilterArray] = useState([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [openAddForm, setOpenAddForm] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [controls, setControls] = useState(initialControls);
  const [establecimientos, setEstablecimientos] = useState([]);
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.LEADS_ADMIN];
  const vertical = "TVS";

  const fetchEstablecimiento = async () => {
    const { success, data } = await getEstablecimientoTvs();
    if (success) {
      setEstablecimientos(data);
      setFilterArray(data);
    } else {
      console.log('error');
    }
  };

  const filterSocios = ({ socio, param, value }) => {
    const empty = !value || value === '0';
    switch (param) {
      case 'linea': {
        const brand = (socio.establecimientoVehiculos || []).map(
          (marca) => marca.nombre_vehiculo,
        );
        return brand.includes(value) || empty;
      }
      case 'estado': {
        const estado = value === 'SI' ? '1' : '0';
        return socio[param] === estado || empty;
      }
      case 'impulsa': {
        const estado = value === 'SI' ? '1' : '0';
        return socio[param] === estado || empty;
      }
      default: {
        const validSocio = String(socio[param]) === value;
        return validSocio || empty;
      }
    }
  };

  /** metodo de los filtros */
  const handleChange = (filter, value) => {
    Object.assign(searchArray, { [filter]: value });
    const updatedSocios = Object.keys(searchArray).reduce(
      (reducedSocios, filterKey) => {
        reducedSocios = reducedSocios.filter((socio) => filterSocios({
          socio,
          param: filterKey,
          value: searchArray[filterKey],
        }));
        return reducedSocios;
      },
      establecimientos,
    );
    setFilterArray(updatedSocios);
  };

  const handleChangeDepartment = (key, value) => {
    setFilteredCities([]);
    const newCiudades = municipios;
    let result = [];
    Object.assign(searchArray, { ciudad: null });
    if (key === 'departamento' && value != '0') {
      result = newCiudades?.filter((item) => {
        if (item.NOMBRE_DPT === value) {
          return item;
        }
      });
    }
    const sortCity = result.sort((a, b) => {
      if (a.NOMBRE_MPI > b.NOMBRE_MPI) {
        return 1;
      }
      if (a.NOMBRE_MPI < b.NOMBRE_MPI) {
        return -1;
      }
      return 0;
    });
    handleChange(key, value);
    setFilteredCities(sortCity);
  };

  // peticiones API

  const handleSubmit = async (e) => {
    e.preventDefault();
    setOpenAddForm(false);
    if (isEdit) {
      const { success } = await putEstablecimiento({
        ...form,
      });
      if (success) {
        fetchEstablecimiento();
        swal(swalMessages.SUCCESSFUL_MESSAGE);
      } else {
        swal(swalMessages.GENERAL_ERROR);
      }
    } else {
      const { id, success } = await postEstablecimiento({
        vertical: 2,
        ...form,
      });
      if (id && success) {
        fetchEstablecimiento();
        swal(swalMessages.SUCCESSFUL_MESSAGE);
      } else {
        swal(swalMessages.GENERAL_ERROR);
      }
    }
    setIsEdit(false);
    setForm(initialForm);
    setControls(initialControls);
    handleChange('lineas', '');
  };

  const handleDelete = async (rowData) => {
    swal(swalMessages.DELETE_CONFIRM).then((willDelete) => {
      if (willDelete) {
        const response = deleteEstablecimiento(rowData.id);
        if (response) {
          const updated = establecimientos.filter(
            (establecimiento) => establecimiento.id !== rowData.id,
          );
          const updatedSocios = filterArray.filter(
            (establecimiento) => establecimiento.id !== rowData.id,
          );
          setFilterArray(updatedSocios);
          setEstablecimientos(updated);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const fetchVehiculos = async () => {
    const { success, data } = await getVehiculos();
    if (success) {
      setVehiculos(data);
    } else {
      console.log('error');
    }
  };

  const fetchDepartamentos = async () => {
    const { success, data } = await getDepartamentos();
    if (success) {
      setDepartamentos(data);
    } else {
      console.log('error');
    }
  };

  const fetchMunicipios = async () => {
    const { success, data } = await getMunicipios();
    if (success) {
      const sortCity = data.sort((a, b) => {
        if (a.NOMBRE_MPI > b.NOMBRE_MPI) {
          return 1;
        }
        if (a.NOMBRE_MPI < b.NOMBRE_MPI) {
          return -1;
        }
        return 0;
      });
      setMunicipios(sortCity);
    } else {
      console.log('error');
    }
  };

  const dobleCheck = (array, principal, secundary) => {
    if (principal !== 'nombre_ciudad') {
      const firstResult = array?.map((item) => ({
        label: item[principal],
        value: item[secundary],
      }));
      const secondResult = array?.map((item) => Number(item[secundary]));
      return { firstResult, secondResult };
    }
    const firstResult = array?.map((item) => ({
      label: `${item[principal]} (${item[secundary]})`,
      value: item[principal],
    }));
    const secondResult = array?.map((item) => ({
      ciudad: item[principal],
      departamento: item[secundary],
    }));
    return { firstResult, secondResult };
  };

  // Control INPUTS
  const onChangeInputs = (value, field) => {
    switch (field) {
      case 'ciudad':
        {
          const ciudad = value?.value;
          const departamento = value?.value2;
          setForm({ ...form, ciudad, departamento });
          setControls({ ...controls, ciudadControl: value });
        }
        break;
      case 'establecimientoCiudades':
        {
          const valuesTo = value.map((item) => ({
            ciudad: item.value,
            departamento: item.value2,
          }));
          setForm({ ...form, [field]: valuesTo });
          setControls({ ...controls, sucursalesControl: value });
        }
        break;
      case 'establecimientoVehiculos': {
        const valuesTo = dobleCheck(value, 'label', 'value');
        setForm({ ...form, [field]: valuesTo.secondResult });
        setControls({ ...controls, vehiculosControl: value });
      }
        break;
      case 'establecimientoTestdriveVehiculos':
        {
          const valuesTo = dobleCheck(value, 'label', 'value');
          setForm({ ...form, [field]: valuesTo.secondResult });
          setControls({ ...controls, testDriveControl: value });
        }
        break;
      default: setForm({ ...form, [field]: value });
        break;
    }
  };

  // open and Close modal
  const onOpenForm = (evento, data) => {
    if (evento === 'edit') {
      const rowSelected = establecimientos
        .filter((establecimiento) => establecimiento.id === data.id)
        .pop();
      const sucursales = dobleCheck(
        rowSelected.establecimientoCiudades,
        'nombre_ciudad',
        'nombre_departamento',
      );
      const testDrive = dobleCheck(
        rowSelected.establecimientoTestdriveVehiculos,
        'nombre_vehiculo',
        'id_vehiculo',
      );
      const stockVehiculos = dobleCheck(
        rowSelected.establecimientoVehiculos,
        'nombre_vehiculo',
        'id_vehiculo',
      );
      setControls({
        ...controls,
        ciudadControl:
          {
            label: `${data.ciudad} (${data.departamento})`,
            value: data.ciudad,
            value2: data.departamento,
          },
        vehiculosControl: stockVehiculos.firstResult,
        testDriveControl: testDrive.firstResult,
        sucursalesControl: sucursales.firstResult,
      });
      setForm({
        ...rowSelected,
        establecimientoTestdriveVehiculos: testDrive.secondResult,
        establecimientoCiudades: sucursales.secondResult,
        establecimientoVehiculos: stockVehiculos.secondResult,
      });
      setIsEdit(true);
    }
    setOpenAddForm(true);
  };

  const onCloseForm = () => {
    setIsEdit(false);
    setControls(initialControls);
    setOpenAddForm(false);
    setForm(initialForm);
    setOpenDetails(false);
  };

  const onOpenDetails = (rowData) => {
    setOpenDetails(true);
    setDetails(rowData);
  };

  useEffect(() => {
    fetchVehiculos();
    fetchMunicipios();
    fetchDepartamentos();
    fetchEstablecimiento();
  }, []);

  return (
    <EstablecimientosPage
      form={form}
      vertical={vertical}
      isEdit={isEdit}
      details={details}
      controls={controls}
      ciudades={municipios}
      vehiculos={vehiculos}
      onOpenForm={onOpenForm}
      onCloseForm={onCloseForm}
      openAddForm={openAddForm}
      permitValue={permitValue}
      openDetails={openDetails}
      handleDelete={handleDelete}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      onOpenDetails={onOpenDetails}
      departamentos={departamentos}
      establecimientos={filterArray}
      onChangeInputs={onChangeInputs}
      filteredCities={filteredCities}
      controlComponent={establecimientos}
      handleChangeDepartment={handleChangeDepartment}
    />
  );
};

export default EstablecimientosTVSContainer;
